// @flow

import * as React from 'react';
import Group from 'sail/Group';
import {Caption} from 'sail/Text';
import type {Article} from 'docs/data';
import {XRaySidebarSection} from './XRaySidebarSection';
import {GatedContentSwitchList} from './GatedContentSwitchList';

type GatesListProps = {|
  article: Article,
|};

export const GatesList = ({article}: GatesListProps) => {
  if (!article.xray || !article.xray.conditions) {
    console.warn('Missing necessary x-ray data. Please contact #docs-product!'); // eslint-disable-line no-console
    return null;
  }

  const conditions = article.xray.conditions;

  const all = [...conditions.inline];

  const gates = all.filter((c) => c.type === 'gate' && c.valid);

  let content;
  if (gates.length === 0) {
    content = <Caption>None</Caption>;
  } else {
    content = (
      <GatedContentSwitchList
        type="gate"
        keys={gates.map((g) => g.name)}
        article={article}
      />
    );
  }

  return (
    <XRaySidebarSection
      title="Inline Gates in Use"
      hint="These are the gates which are referenced in this article. By default, gates are set to true on Stripe machines."
    >
      <Group spacing={4}>{content}</Group>
    </XRaySidebarSection>
  );
};
